// Wynridge — content + the brand assets extracted from the provided design HTML.
// Assets live in /public/brand and are the exact images from the original file.
const PUB = process.env.PUBLIC_URL || "";
const b = (f) => `${PUB}/brand/${f}`;

export const BRAND = {
  logoWhite: b("41e6c280.png"), // wordmark for dark nav / over hero
  logoInk: b("a7b4689a.png"),   // wordmark for scrolled nav + footer
  markBadge: b("e1e4a599.png"), // small mark used in hero badge + quote avatar
  mark: b("8b485599.png"),      // monogram mark used in manifesto / news / service icons
  favicon: b("05334679.png"),
};

export const IMAGES = {
  hero: b("c6140912.jpg"),
  residence: b("94a0212f.jpg"),
  travel: b("7c24157d.jpg"),
  lounge: b("e56909bf.jpg"),
  suite: b("ba656483.jpg"),
  statsDeck: b("5d9f7029.jpg"),
  dining: b("5d3905ba.jpg"),
  studio: b("8454a76e.jpg"),
  grounds: b("338359cb.jpg"),
};

export const NAV_LINKS = [
  { label: "Story", href: "#story" },
  { label: "Life", href: "#life" },
  { label: "Community", href: "#community" },
];

export const VALUES = [
  {
    img: IMAGES.residence,
    alt: "A pristine, low-maintenance residence",
    title: "Maintenance-free, forever",
    text: "No snow to shovel. No roof to fix. No surprise repair bills — ever.",
  },
  {
    img: IMAGES.travel,
    alt: "Packed and ready to travel",
    title: "Lock up and go",
    text: "Travel for a month without a second thought. Your home waits, worry-free.",
    dark: true,
    more: "How it works",
  },
  {
    img: IMAGES.lounge,
    alt: "Friends gathered in the lounge",
    title: "Friends down the hall",
    text: "A built-in community and a calendar full of reasons to step out your door.",
  },
  {
    img: IMAGES.suite,
    alt: "A bright, modern suite",
    title: "Suites you'll love",
    text: "Bright, modern, accessible homes designed around you.",
  },
];

export const STATS = [
  { n: "55+", l: "Designed exclusively for active adults" },
  { n: "0", l: "Chores, repairs, or worries" },
  { n: "365", l: "Days of community, every year" },
];

export const QUOTE = {
  name: "Susan, 68",
  role: "The resident we're designing for",
  text: "\u201cI want less responsibility, more freedom, and a community where I can keep living life to the fullest.\u201d",
  tag: "Why People Will Choose Wynridge",
};

export const SERVICES = [
  {
    icon: BRAND.mark,
    title: "Independence",
    text: "A suite that's entirely your own, designed to flex with you — with support on hand the day you want it, and never a day before.",
  },
  {
    img: IMAGES.dining,
    alt: "Residents sharing a meal",
    title: "Connection",
    text: "Shared kitchens, sunlit lounges, and resident-led programming that turn neighbours into the people you can't wait to see.",
    image: true,
  },
  {
    icon: BRAND.mark,
    title: "Freedom",
    text: "Unlock your home's equity, shed the maintenance, and pour all that reclaimed time into whatever you've been waiting for.",
  },
];

export const GALLERY = [
  { img: IMAGES.lounge, alt: "The lounge", t: "The Lounge", c: "Fireside chairs and easy company." },
  { img: IMAGES.studio, alt: "Maker studio", t: "Studios & Making", c: "Hands full. Days fuller." },
  { img: IMAGES.statsDeck, alt: "Wellness", t: "Wellness & Movement", c: "Strong, steady, and in good company." },
  { img: IMAGES.grounds, alt: "The grounds", t: "The Grounds", c: "Trails, gardens, and room to roam." },
];

export const FAQS = [
  {
    q: "How is Wynridge different from what's out there?",
    a: "Completely. Wynridge is independent, design-led living for active adults — a genuine community of beautiful homes and shared spaces, with none of the institutional feel you might be picturing.",
    open: true,
  },
  {
    q: "Who is Wynridge for?",
    a: "Active, independent adults 55+ who are done with the upkeep and ready to get far more out of life.",
  },
  {
    q: "What's included?",
    a: "A maintenance-free suite, beautiful shared spaces, resident-led programming, and a community that feels like one from day one.",
  },
  {
    q: "When can I move in?",
    a: "Our first communities are coming soon. Join the list for opening dates and first access.",
  },
];
